"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tauri_inliner_1 = __importDefault(require("@tauri-apps/tauri-inliner"));
var toml_1 = __importDefault(require("@tauri-apps/toml"));
var chokidar_1 = __importDefault(require("chokidar"));
var fs_extra_1 = require("fs-extra");
var jsdom_1 = require("jsdom");
var lodash_1 = require("lodash");
var path_1 = __importDefault(require("path"));
var http_1 = __importDefault(require("http"));
var os_1 = __importDefault(require("os"));
var net_1 = require("./helpers/net");
var app_paths_1 = require("./helpers/app-paths");
var logger_1 = __importDefault(require("./helpers/logger"));
var on_shutdown_1 = __importDefault(require("./helpers/on-shutdown"));
var spawn_1 = require("./helpers/spawn");
var child_process_1 = require("child_process");
var tauri_config_1 = __importDefault(require("./helpers/tauri-config"));
var http_proxy_1 = __importDefault(require("http-proxy"));
var is_reachable_1 = __importDefault(require("is-reachable"));
var chalk_1 = __importDefault(require("chalk"));
var log = logger_1.default('app:tauri');
var warn = logger_1.default('app:tauri (runner)', chalk_1.default.red);
var WATCHER_INTERVAL = 1000;
var Runner = /** @class */ (function () {
    function Runner() {
        var _this = this;
        this.rewritingToml = false;
        this.pid = 0;
        this.tauriWatcher = undefined;
        on_shutdown_1.default(function () {
            _this.stop().catch(function (e) {
                throw e;
            });
        });
    }
    Runner.prototype.run = function (cfg) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var devPath, ls, devTryCount, devTryTimeout_1, cargoManifest, runningDevServer, inlinedAssets, self_1, devUrl_1, proxy_1, proxyServer, port, devServer, startDevTauri, tauriPaths, tauriPath;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        devPath = cfg.build.devPath;
                        if (!this.pid) return [3 /*break*/, 2];
                        if (!(this.devPath !== devPath)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stop()];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!(!this.beforeDevProcess && cfg.build.beforeDevCommand)) return [3 /*break*/, 6];
                        log('Running `' + cfg.build.beforeDevCommand + '`');
                        ls = child_process_1.exec(cfg.build.beforeDevCommand, {
                            cwd: app_paths_1.appDir,
                            env: process.env
                        }, function (error) {
                            if (error) {
                                process.exit(1);
                            }
                        });
                        (_a = ls.stderr) === null || _a === void 0 ? void 0 : _a.pipe(process.stderr);
                        (_b = ls.stdout) === null || _b === void 0 ? void 0 : _b.pipe(process.stdout);
                        this.beforeDevProcess = ls;
                        devTryCount = 0;
                        devTryTimeout_1 = 3000;
                        _c.label = 3;
                    case 3: return [4 /*yield*/, is_reachable_1.default(devPath)];
                    case 4:
                        if (!!(_c.sent())) return [3 /*break*/, 6];
                        log('Waiting for your dev server to start...');
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, devTryTimeout_1); })];
                    case 5:
                        _c.sent();
                        devTryCount++;
                        if (devTryCount === 10) {
                            warn("Couldn't connect to " + devPath + " after " + (devTryTimeout_1 * devTryCount) / 1000 + "s. Please make sure that's the URL to your dev server.");
                            process.exit(1);
                        }
                        return [3 /*break*/, 3];
                    case 6:
                        cargoManifest = this.__getManifest();
                        this.__allowlistApi(cfg, cargoManifest);
                        this.__rewriteManifest(cargoManifest);
                        runningDevServer = devPath.startsWith('http');
                        inlinedAssets = [];
                        if (!runningDevServer) return [3 /*break*/, 8];
                        self_1 = this;
                        devUrl_1 = new URL(devPath);
                        proxy_1 = http_proxy_1.default.createProxyServer({
                            ws: true,
                            target: {
                                host: devUrl_1.hostname,
                                port: devUrl_1.port
                            },
                            selfHandleResponse: true
                        });
                        proxy_1.on('proxyRes', function (proxyRes, req, res) {
                            if (req.url === '/') {
                                var body_1 = [];
                                proxyRes.on('data', function (chunk) {
                                    body_1.push(chunk);
                                });
                                proxyRes.on('end', function () {
                                    var bodyStr = body_1.join('');
                                    var indexDir = os_1.default.tmpdir();
                                    fs_extra_1.writeFileSync(path_1.default.join(indexDir, 'index.html'), bodyStr);
                                    self_1
                                        .__parseHtml(cfg, indexDir, false)
                                        .then(function (_a) {
                                        var html = _a.html;
                                        var headers = {};
                                        if (proxyRes.headers['content-type']) {
                                            headers['content-type'] = proxyRes.headers['content-type'];
                                        }
                                        else {
                                            var charsetMatch = /charset="(\S+)"/g.exec(bodyStr);
                                            if (charsetMatch) {
                                                headers['content-type'] = "'text/html; charset=" + charsetMatch[1];
                                            }
                                        }
                                        res.writeHead(200, headers);
                                        res.end(html);
                                    })
                                        .catch(function (err) {
                                        res.writeHead(500, JSON.stringify(err));
                                        res.end();
                                    });
                                });
                            }
                            else {
                                if (proxyRes.statusCode) {
                                    res = res.writeHead(proxyRes.statusCode, proxyRes.headers);
                                }
                                proxyRes.pipe(res);
                            }
                        });
                        proxy_1.on('error', function (error, _, res) {
                            var _a;
                            if ((_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('ECONNREFUSED')) {
                                warn("Connection refused to " + devUrl_1.protocol + "//" + devUrl_1.host + ". Did you start your dev server? Usually that's done with a `dev` or `serve` NPM script.");
                            }
                            else {
                                console.error(error);
                            }
                            res.writeHead(500, error.message);
                        });
                        proxyServer = http_1.default.createServer(function (req, res) {
                            delete req.headers['accept-encoding'];
                            proxy_1.web(req, res);
                        });
                        proxyServer.on('upgrade', function (req, socket, head) {
                            proxy_1.ws(req, socket, head);
                        });
                        return [4 /*yield*/, net_1.findClosestOpenPort(parseInt(devUrl_1.port) + 1, devUrl_1.hostname)];
                    case 7:
                        port = _c.sent();
                        devServer = proxyServer.listen(port);
                        this.devServer = devServer;
                        devPath = devUrl_1.protocol + "//localhost:" + port;
                        cfg.build.devPath = devPath;
                        process.env.TAURI_CONFIG = JSON.stringify(cfg);
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, this.__parseHtml(cfg, devPath)];
                    case 9:
                        inlinedAssets = (_c.sent()).inlinedAssets;
                        _c.label = 10;
                    case 10:
                        process.env.TAURI_INLINED_ASSETS = inlinedAssets.join('|');
                        this.devPath = devPath;
                        startDevTauri = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.__runCargoCommand({
                                            cargoArgs: ['run'],
                                            dev: true,
                                            exitOnPanic: cfg.ctx.exitOnPanic
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        tauriPaths = [];
                        if (typeof cargoManifest.dependencies.tauri !== 'string' &&
                            cargoManifest.dependencies.tauri.path) {
                            tauriPath = path_1.default.resolve(app_paths_1.tauriDir, cargoManifest.dependencies.tauri.path);
                            tauriPaths = [
                                tauriPath,
                                tauriPath + "-api",
                                tauriPath + "-updater",
                                tauriPath + "-utils"
                            ];
                        }
                        if (!this.tauriWatcher) {
                            // eslint-disable-next-line security/detect-non-literal-fs-filename
                            this.tauriWatcher = chokidar_1.default
                                .watch(__spreadArrays([
                                path_1.default.join(app_paths_1.tauriDir, 'src'),
                                path_1.default.join(app_paths_1.tauriDir, 'Cargo.toml'),
                                path_1.default.join(app_paths_1.tauriDir, 'build.rs'),
                                path_1.default.join(app_paths_1.tauriDir, 'tauri.conf.json')
                            ], tauriPaths).concat(runningDevServer ? [] : [devPath]), {
                                ignoreInitial: true,
                                ignored: [
                                    runningDevServer ? null : path_1.default.join(devPath, 'index.tauri.html')
                                ].concat(path_1.default.join(app_paths_1.tauriDir, 'target'))
                            })
                                .on('change', lodash_1.debounce(function (changedPath) {
                                if (_this.rewritingToml &&
                                    changedPath.startsWith(path_1.default.join(app_paths_1.tauriDir, 'Cargo.toml'))) {
                                    return;
                                }
                                ;
                                (_this.pid ? _this.__stopCargo() : Promise.resolve())
                                    .then(function () {
                                    var shouldTriggerRun = changedPath.includes('tauri.conf.json') ||
                                        changedPath.startsWith(devPath);
                                    if (shouldTriggerRun) {
                                        _this.run(tauri_config_1.default({ ctx: cfg.ctx })).catch(function (e) {
                                            throw e;
                                        });
                                    }
                                    else {
                                        startDevTauri().catch(function (e) {
                                            throw e;
                                        });
                                    }
                                })
                                    .catch(function (err) {
                                    warn(err);
                                    process.exit(1);
                                });
                            }, WATCHER_INTERVAL));
                        }
                        return [2 /*return*/, startDevTauri()];
                }
            });
        });
    };
    Runner.prototype.build = function (cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, command, args, cargoManifest, inlinedAssets, features, buildFn, targets, _i, targets_1, target;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (cfg.build.beforeBuildCommand) {
                            _a = cfg.build.beforeBuildCommand.split(' '), command = _a[0], args = _a.slice(1);
                            spawn_1.spawnSync(command, args, app_paths_1.appDir);
                        }
                        cargoManifest = this.__getManifest();
                        this.__allowlistApi(cfg, cargoManifest);
                        this.__rewriteManifest(cargoManifest);
                        return [4 /*yield*/, this.__parseHtml(cfg, cfg.build.distDir)];
                    case 1:
                        inlinedAssets = (_b.sent())
                            .inlinedAssets;
                        process.env.TAURI_INLINED_ASSETS = inlinedAssets.join('|');
                        features = [
                            cfg.tauri.embeddedServer.active ? 'embedded-server' : 'no-server'
                        ];
                        buildFn = function (target) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.__runCargoCommand({
                                            cargoArgs: __spreadArrays([
                                                cfg.tauri.bundle.active ? 'tauri-bundler' : 'build',
                                                '--features'
                                            ], features, (cfg.tauri.bundle.active &&
                                                Array.isArray(cfg.tauri.bundle.targets) &&
                                                cfg.tauri.bundle.targets.length
                                                ? ['--format'].concat(cfg.tauri.bundle.targets)
                                                : [])).concat(cfg.ctx.debug ? [] : ['--release'])
                                                .concat(cfg.verbose ? ['--verbose'] : [])
                                                .concat(target ? ['--target', target] : [])
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        if (!!cfg.ctx.target) return [3 /*break*/, 3];
                        // if no target specified,
                        // build only for the current platform
                        return [4 /*yield*/, buildFn()];
                    case 2:
                        // if no target specified,
                        // build only for the current platform
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        targets = cfg.ctx.target.split(',');
                        _i = 0, targets_1 = targets;
                        _b.label = 4;
                    case 4:
                        if (!(_i < targets_1.length)) return [3 /*break*/, 7];
                        target = targets_1[_i];
                        return [4 /*yield*/, buildFn(target)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    Runner.prototype.__parseHtml = function (cfg, indexDir, inlinerEnabled) {
        if (inlinerEnabled === void 0) { inlinerEnabled = cfg.tauri.inliner.active; }
        return __awaiter(this, void 0, void 0, function () {
            var inlinedAssets;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inlinedAssets = [];
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var indexPath = path_1.default.join(indexDir, 'index.html');
                                if (!fs_extra_1.existsSync(indexPath)) {
                                    warn("Error: cannot find index.html in \"" + indexDir + "\". Did you forget to build your web code or update the build.distDir in tauri.conf.json?");
                                    reject(new Error('Could not find index.html in dist dir.'));
                                }
                                var originalHtml = fs_extra_1.readFileSync(indexPath).toString();
                                var rewriteHtml = function (html, interceptor) {
                                    var dom = new jsdom_1.JSDOM(html);
                                    var document = dom.window.document;
                                    if (interceptor !== undefined) {
                                        interceptor(dom);
                                    }
                                    if (!(
                                    /* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
                                    ((cfg.ctx.dev && cfg.build.devPath.startsWith('http')) ||
                                        cfg.tauri.embeddedServer.active)
                                    /* eslint-enable */
                                    )) {
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                                        var mutationObserverTemplate = require('../templates/mutation-observer')
                                            .default;
                                        var compiledMutationObserver = lodash_1.template(mutationObserverTemplate);
                                        var bodyMutationObserverScript = document.createElement('script');
                                        bodyMutationObserverScript.text = compiledMutationObserver({
                                            target: 'body',
                                            inlinedAssets: JSON.stringify(inlinedAssets)
                                        });
                                        document.body.insertBefore(bodyMutationObserverScript, document.body.firstChild);
                                        var headMutationObserverScript = document.createElement('script');
                                        headMutationObserverScript.text = compiledMutationObserver({
                                            target: 'head',
                                            inlinedAssets: JSON.stringify(inlinedAssets)
                                        });
                                        document.head.insertBefore(headMutationObserverScript, document.head.firstChild);
                                    }
                                    var tauriScript = document.createElement('script');
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                                    tauriScript.text = require('../templates/tauri.js').default;
                                    document.head.insertBefore(tauriScript, document.head.firstChild);
                                    if (cfg.build.withGlobalTauri) {
                                        var tauriUmdScript = document.createElement('script');
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                                        tauriUmdScript.text = require('../api/tauri.bundle.umd').default;
                                        document.head.insertBefore(tauriUmdScript, document.head.firstChild);
                                    }
                                    var csp = cfg.tauri.security.csp;
                                    if (csp) {
                                        var cspTag = document.createElement('meta');
                                        cspTag.setAttribute('http-equiv', 'Content-Security-Policy');
                                        cspTag.setAttribute('content', csp);
                                        document.head.appendChild(cspTag);
                                    }
                                    var newHtml = dom.serialize();
                                    fs_extra_1.writeFileSync(path_1.default.join(indexDir, 'index.tauri.html'), newHtml);
                                    return newHtml;
                                };
                                var domInterceptor = cfg.tauri.embeddedServer.active
                                    ? undefined
                                    : function (dom) {
                                        var document = dom.window.document;
                                        if (!cfg.ctx.dev) {
                                            document
                                                .querySelectorAll('link')
                                                .forEach(function (link) {
                                                link.removeAttribute('rel');
                                                link.removeAttribute('as');
                                            });
                                        }
                                    };
                                if (
                                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                (!cfg.ctx.dev && cfg.tauri.embeddedServer.active) ||
                                    !inlinerEnabled) {
                                    var html = rewriteHtml(originalHtml, domInterceptor);
                                    resolve({ inlinedAssets: inlinedAssets, html: html });
                                }
                                else {
                                    var cwd_1 = process.cwd();
                                    process.chdir(indexDir); // the inliner requires this to properly work
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                                    var inliner = new tauri_inliner_1.default({ source: originalHtml }, function (err, html) {
                                        process.chdir(cwd_1); // reset CWD
                                        if (err) {
                                            reject(err);
                                        }
                                        else {
                                            var rewrittenHtml = rewriteHtml(html, domInterceptor);
                                            resolve({ inlinedAssets: inlinedAssets, html: rewrittenHtml });
                                        }
                                    });
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                                    inliner.on('progress', function (event) {
                                        var match = event.match(/([\S\d]+)\.([\S\d]+)/g);
                                        match && inlinedAssets.push(match[0]);
                                    });
                                }
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Runner.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var _a, _b;
                            (_a = _this.devServer) === null || _a === void 0 ? void 0 : _a.close();
                            (_b = _this.tauriWatcher) === null || _b === void 0 ? void 0 : _b.close().catch(reject);
                            _this.__stopCargo().then(resolve).catch(reject);
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Runner.prototype.__runCargoCommand = function (_a) {
        var cargoArgs = _a.cargoArgs, extraArgs = _a.extraArgs, _b = _a.dev, dev = _b === void 0 ? false : _b, _c = _a.exitOnPanic, exitOnPanic = _c === void 0 ? true : _c;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                            _this.pid = spawn_1.spawn('cargo', extraArgs ? cargoArgs.concat(['--']).concat(extraArgs) : cargoArgs, app_paths_1.tauriDir, function (code, pid) {
                                if (_this.killPromise) {
                                    _this.killPromise();
                                    _this.killPromise = undefined;
                                    resolve();
                                    return;
                                }
                                if (pid !== _this.pid) {
                                    resolve();
                                    return;
                                }
                                if (dev && !exitOnPanic && code === 101) {
                                    _this.pid = 0;
                                    resolve();
                                    return;
                                }
                                if (code) {
                                    warn();
                                    warn('⚠️  [FAIL] Cargo CLI has failed');
                                    warn();
                                    reject(new Error('Cargo failed with status code ' + code.toString()));
                                    process.exit(1);
                                }
                                else if (!dev) {
                                    resolve();
                                }
                                if (dev) {
                                    warn();
                                    warn('Cargo process was killed. Exiting...');
                                    warn();
                                    process.exit(0);
                                }
                                resolve();
                            });
                            if (dev) {
                                resolve();
                            }
                        })];
                    case 1: return [2 /*return*/, _d.sent()];
                }
            });
        });
    };
    Runner.prototype.__stopCargo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.pid) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.resolve()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        log('Shutting down tauri process...');
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                _this.killPromise = resolve;
                                try {
                                    process.kill(_this.pid);
                                    _this.pid = 0;
                                }
                                catch (e) {
                                    reject(e);
                                }
                            })];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Runner.prototype.__getManifestPath = function () {
        return path_1.default.join(app_paths_1.tauriDir, 'Cargo.toml');
    };
    Runner.prototype.__getManifest = function () {
        var tomlPath = this.__getManifestPath();
        var tomlFile = fs_extra_1.readFileSync(tomlPath).toString();
        var cargoManifest = toml_1.default.parse(tomlFile);
        return cargoManifest;
    };
    Runner.prototype.__rewriteManifest = function (cargoManifest) {
        var _this = this;
        var tomlPath = this.__getManifestPath();
        var output = toml_1.default.stringify(cargoManifest);
        this.rewritingToml = true;
        fs_extra_1.writeFileSync(tomlPath, output);
        setTimeout(function () {
            _this.rewritingToml = false;
        }, WATCHER_INTERVAL * 2);
    };
    Runner.prototype.__allowlistApi = function (cfg, manifest) {
        var tomlFeatures = [];
        if (cfg.tauri.allowlist.all) {
            tomlFeatures.push('all-api');
        }
        else {
            var toKebabCase = function (value) {
                return value
                    .replace(/([a-z])([A-Z])/g, '$1-$2')
                    .replace(/\s+/g, '-')
                    .toLowerCase();
            };
            var allowlist = Object.keys(cfg.tauri.allowlist).filter(function (w) { return cfg.tauri.allowlist[String(w)]; });
            tomlFeatures.push.apply(tomlFeatures, allowlist.map(toKebabCase));
        }
        if (cfg.tauri.cli) {
            tomlFeatures.push('cli');
        }
        if (typeof manifest.dependencies.tauri === 'string') {
            manifest.dependencies.tauri = {
                version: manifest.dependencies.tauri,
                features: tomlFeatures
            };
        }
        else {
            manifest.dependencies.tauri.features = tomlFeatures;
        }
    };
    return Runner;
}());
exports.default = Runner;
